import enTranslation from "../components/Translations/en.json";
import cnTranslation from "../components/Translations/cn.json";
import jpTranslation from "../components/Translations/jp.json";
import krTranslation from "../components/Translations/kr.json";

export default function FetchResources() {
  return {
    English: { translation: enTranslation },
    China: { translation: cnTranslation },
    Japan: { translation: jpTranslation },
    Korea: { translation: krTranslation },
  };
}

function Languagesymbols(){
  return{
    English:"en",
    China: "zh",
    Japan: "ja",
    Korea: "ko",
    default:"en"
  }
}

export  function GetConvertedLangsymbols(language){
  const lang = Languagesymbols();
  const result_lang = lang[language]
  return result_lang ? result_lang : lang["default"]
}

export  function GetLanguage(langsymbols){
  const lang = Languagesymbols();
  let result_lang = Object.keys(lang).find(x => lang[x] === langsymbols);
  return result_lang ? result_lang : Object.keys(lang).find(x => lang[x] === 'en')
}